import React, { useState, useEffect, useRef, useCallback } from "react";
import { useTranslation } from "react-i18next";
import axios from "axios";
import $ from "jquery";
import ReactLoading from "react-loading";

import PopUp from "./PopUp.js";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

const BilderManagement = (props) => {
  const { t } = useTranslation();

  const link = localStorage.getItem("link");
  const token = localStorage.getItem("JWT");

  const [popUpShow, setPopUpShow] = useState(false);
  const [thumbnailsLoading, setThumbnailsLoading] = useState(false);

  // rendered images with blob URLs
  const [renderImages, setRenderImages] = useState([]);

  const popUpContainer = useRef(null);

  const loadProtectedImage = useCallback(async (url) => {
    try {
      const response = await axios.get(`${link}${url}`, {
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      return URL.createObjectURL(response.data);
    } catch (error) {
      console.error("Image load failed", error);
      return null;
    }
  }, [link, token]);

  const prepareImages = useCallback(async () => {
    setThumbnailsLoading(true);

    try {
      const images = props.data || [];
      const prepared = await Promise.all(
        images.map(async (img) => {
          const thumbnailBlobUrl = await loadProtectedImage(img.thumbnailUrl);

          return {
            ...img,
            thumbnailBlobUrl,
          };
        }),
      );

      setRenderImages(prepared);
    } catch (error) {
      console.error(error);
    } finally {
      setThumbnailsLoading(false);
    }
  }, [props.data, loadProtectedImage]);

  useEffect(() => {
    prepareImages();
  }, [prepareImages]);

  useEffect(() => {
    return () => {
      renderImages.forEach((img) => {
        if (img.thumbnailBlobUrl) {
          URL.revokeObjectURL(img.thumbnailBlobUrl);
        }
      });
    };
  }, [renderImages]);

  useEffect(() => {
    const handleClick = (e) => {
      if (
        popUpContainer.current &&
        !popUpContainer.current.contains(e.target) &&
        e.target.id !== "settings-icon" &&
        !$(e.target).is(".settings-item") &&
        !$(e.target).children().hasClass("settings-item") &&
        !$(e.target).hasClass("select-icon") &&
        !$(e.target).parents(".rc-time-picker-panel").length &&
        !$(e.target).hasClass("rc-time-picker-clear") &&
        !$(e.target).hasClass("rc-time-picker-clear-icon") &&
        e.target.id !== "pop-up-button"
      ) {
        setPopUpShow(false);
      }
    };

    $(document).on("click", handleClick);

    return () => {
      $(document).off("click", handleClick);
    };
  }, []);

  const uploadImage = () => {
    setPopUpShow(true);
  };

  const popUpChange = () => {
    props.onChange();
    setPopUpShow(false);
  };

  const deleteImage = (imageData) => {
    const id = imageData.id;

    confirmAlert({
      message: t("allgemein.bestaetigen"),

      buttons: [
        {
          label: t("allgemein.ja"),

          onClick: async () => {
            try {
              await axios.delete(
                `${link}/api/SmartSignageBackgroundImage?id=${id}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                },
              );

              props.onChange();
            } catch (error) {
              console.error(error);
            }
          },
        },

        {
          label: t("allgemein.nein"),
        },
      ],
    });
  };

  const renderImageList = () => {
    return (
      <tbody>
        {renderImages.map((img) => (
          <tr key={img.id}>
            <td className="image-column">
              <div className="thumbnail-wrapper">
                {img.thumbnailBlobUrl ? (
                  <img
                    src={img.thumbnailBlobUrl}
                    alt={img.name}
                    className="image-thumb"
                  />
                ) : (
                  <div className="image-placeholder">
                    {t("administration.imageManagement.noImage")}
                  </div>
                )}
              </div>
            </td>

            <td>{img.name}</td>

            <td>
              <button
                className="button"
                id="pop-up-button"
                style={{
                  width: "40px",
                  height: "40px",
                  padding: "3px",
                }}
                onClick={() => deleteImage(img)}
              >
                <i
                  className="bx bx-trash bx-sm"
                  title={t("allgemein.Loeschen")}
                />
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    );
  };

  return (
    <div>
      {popUpShow && (
        <div ref={popUpContainer}>
          <PopUp type={"bilderManagement"} data={null} onChange={popUpChange} />
        </div>
      )}

      <h3>{t("administration.imageManagement.imageManagement")}</h3>

      <div className="einstellungen-box">
        <div className="box-name">
          {t("administration.imageManagement.savedImages")}
        </div>

        <div className="image-table-container">
          {(props.loading || thumbnailsLoading) && (
            <div className="image-loading-overlay">
              <ReactLoading
                type="bars"
                color="#2a3042"
                height={60}
                width={60}
              />
              <span>{t("allgemein.laedt")}</span>
            </div>
          )}
          <table className="image-table">
            <thead>
              <tr>
                <td>{t("administration.imageManagement.image")}</td>
                <td>{t("administration.imageManagement.filename")}</td>
                <td>
                  <button
                    className="button"
                    id="pop-up-button"
                    style={{ width: "50px" }}
                    onClick={uploadImage}
                  >
                    {t("allgemein.Neu")}
                  </button>
                </td>
              </tr>
            </thead>

            {renderImageList()}
          </table>
        </div>
      </div>
    </div>
  );
};

export default BilderManagement;
